import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, cld } from "@/lib/api";
import { ArtworkCard } from "@/components/site/ArtworkCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setData(null);
    setMissing(false);
    api.get(`/categories/${slug}`).then((r) => setData(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) {
    return (
      <div className="container-x py-32" data-testid="category-not-found">
        <h1 className="font-display text-5xl font-light">This collection could not be found.</h1>
        <Link to="/gallery" className="link-u mt-10">Return to the collection</Link>
      </div>
    );
  }
  if (!data) return <div className="container-x py-24"><div className="h-16 w-1/2 animate-pulse bg-[#F2EEE6]" /></div>;

  const { category: c, products } = data;
  return (
    <div data-testid="category-page">
      {c.header_image_url && (
        <div className="aspect-[21/9] max-h-[460px] w-full overflow-hidden bg-[#F2EEE6]" data-testid="category-header-image">
          <img src={cld(c.header_image_url, "w_2000,q_auto,f_auto")} alt={c.name} className="slow-fade h-full w-full object-cover" />
        </div>
      )}
      <div className="container-x py-16 sm:py-24">
        <p className="eyebrow">The collection</p>
        <h1 className="mt-6 font-display text-5xl font-light sm:text-6xl" data-testid="category-title">{c.name}</h1>
        {c.description && <p className="mt-6 max-w-2xl text-[15px] leading-[1.8] text-[#5A626A]" data-testid="category-description">{c.description}</p>}
        <div className="mt-12 border-t border-[#E5E0D8]" />
        {products.length === 0 ? (
          <p className="mt-16 text-sm text-[#5A626A]" data-testid="category-empty">No works in this collection yet.</p>
        ) : (
          <div className="mt-16 grid gap-x-12 gap-y-20 sm:grid-cols-2 lg:grid-cols-3" data-testid="category-grid">
            {products.map((p, i) => <ArtworkCard key={p.id} p={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
